<script>

import FirstCardDesign from '@/components/wizards/digitize/FirstCardDesign.vue';
import SecondCardDesign from '@/components/wizards/digitize/SecondCardDesign.vue';
import ThirdCardDesign from '@/components/wizards/digitize/ThirdCardDesign.vue';
import useMobileStyle from '@/mixins/useMobileStyle';
import { mapActions } from 'vuex';
import bem from '@/utils/bem';
import ChangeWizardCard from '@/components/modals/Change-wizard-card.vue';

const b = bem('digitize-cards');
export default {
  data() {
    return {
      isFirstBlockLoaded: false,
      isSecondBlockLoaded: false,
      isThirdBlockLoaded: false,
      isStartAutoPlay: false,
      designList: [
        { label: 'Card type 1', value: 0 },
        { label: 'Card type 2', value: 1 },
        { label: 'Card type 3', value: 2 },
      ],
      isShowCardModal: false,
    };
  },
  mixins: [useMobileStyle],
  props: {
    selectedStep: {
      type: Object,
      required: true,
    },
    productName: {
      type: String,
      required: true,
    },
    products: {
      type: Array,
      required: true,
    },
  },
  components: {
    ChangeWizardCard,
    FirstCardDesign,
    SecondCardDesign,
    ThirdCardDesign,
  },
  methods: {
    ...mapActions({
      updateWizardCardsOrderAction: 'wizards/updateWizardCardsOrder',
      changeWizardStepDesignAction: 'wizards/changeWizardStepDesign',
    }),
    b(firstArg, secondArg) {
      return b(firstArg, secondArg);
    },
    onLoadedData(key) {
      if (key === 0) {
        this.isFirstBlockLoaded = true;
      }

      if (key === 1) {
        this.isSecondBlockLoaded = true;
      }

      if (key === 2) {
        this.isThirdBlockLoaded = true;
      }
      this.checkAutoPlay();
    },
    checkAutoPlay() {
      const cardsCount = this.selectedStep.orderSections.length;
      this.isStartAutoPlay = Boolean(
        (cardsCount === 1 && this.isFirstBlockLoaded)
          || (cardsCount === 2 && this.isFirstBlockLoaded && this.isSecondBlockLoaded)
          || (
            cardsCount === 3
              && this.isFirstBlockLoaded
              && this.isSecondBlockLoaded
              && this.isThirdBlockLoaded
          ),
      );
    },
    cardsOrderUpdate(currentIndex, newIndex) {
      const currentCard = this.selectedStep.orderSections[currentIndex];
      const anotherCard = this.selectedStep.orderSections[newIndex];
      const newSections = {
        orderSections: [
          {
            id: currentCard.id,
            order: anotherCard.order,
          },
          {
            id: anotherCard.id,
            order: currentCard.order,
          },
        ],
      };
      this.updateWizardCardsOrderAction({ newSections, type: this.productName });
    },
    changeWizardStepDesign(value) {
      const newStepValue = {
        steps: [{
          id: this.selectedStep.id,
          name: this.selectedStep.name,
          designVersion: value,
        }],
      };
      this.changeWizardStepDesignAction({
        newStepValue,
        type: this.productName,
      });
    },
    toggleModals() {
      this.isShowCardModal = true;
    },
  },
};

</script>

<template>
  <div :class="b('')" v-if="products.length > 0">
    <div :class="b('top-buttons')">
      <div :class="b('button')">
        <a-button
            type="primary"
            size="small"
            @click="toggleModals"
        >
          + Add new card
        </a-button>
      </div>
      <div :class="b('button')">
        <a-select
          size="small"
          placeholder="Select design"
          :options="designList"
          :value="selectedStep.designVersion"
          @change="changeWizardStepDesign"
        />
      </div>
    </div>
    <template v-if="isShowCardModal">
      <ChangeWizardCard
          :section="{}"
          title="Wizard card"
          :is-new-card="true"
          :products="products"
          :help-center-list="selectedStep.helpCenters"
          v-model:show="isShowCardModal"
          :product-name="productName"
          :step-id="selectedStep.id"
          :with-toggle="selectedStep.designVersion === 1"
      />
    </template>
    <template v-for="(section, index) in selectedStep.orderSections" v-bind:key="section.id">
      <FirstCardDesign
          :section="section"
          :is-film="false"
          v-if="selectedStep.designVersion === 0"
          :index="index"
          :lastIndex="selectedStep.orderSections.length - 1"
          :cards-order-update="cardsOrderUpdate"
          :products="products"
          :help-center-list="selectedStep.helpCenters"
          :product-name="productName"
      />
      <SecondCardDesign
          :section="section"
          v-else-if="selectedStep.designVersion === 1"
          :designVersion="selectedStep.designVersion"
            :index="index"
            :lastIndex="selectedStep.orderSections.length - 1"
            :product-name="productName"
            :on-loaded-data="onLoadedData"
            :is-start-play="isStartAutoPlay"
            :products="products"
            :help-center-list="selectedStep.helpCenters"
            :cards-order-update="cardsOrderUpdate"
        />
        <ThirdCardDesign
            v-else
            :section="section"
            :index="index"
            :lastIndex="selectedStep.orderSections.length - 1"
            :product-name="productName"
            :size="768"
            :is-mobile-display="isMobileDisplay"
            :cards-order-update="cardsOrderUpdate"
            :products="products"
            :help-center-list="selectedStep.helpCenters"
      />
    </template>
  </div>
</template>

<style scoped lang="scss">
@import "@/styles/media";
.digitize-cards {
  position: relative;
  display: flex;
  margin-top: 60px;

  &__top-buttons {
    position: absolute;
    top: -50px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 2;
    display: flex;
    justify-content: space-between;
  }

  &__button {
    margin: 0 16px;
  }
}
</style>
